import { ADVERTS_SETUP_UPDATE } from '../action-types';

export const setAdvertsSetup = (advertsSetup) => (dispatch) => {
  dispatch({ type: ADVERTS_SETUP_UPDATE, payload: { advertsSetup } });
};
